import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import styles from './styles.scss';

const KeywordList = ({ keywords }) => [
  <Row key="header" className={`mb-3 mx-3 ${styles.header}`}>
    <Col>Keyword</Col>
    <Col>Sample Value</Col>
  </Row>,
  keywords.map(({ keyword, value }) => (
    <Row key={keyword} className={`mb-2 mx-3 ${styles.keywordContainer}`}>
      <Col>
        <div className="d-table h-100">
          <span className={`d-table-cell ${styles.keyword}`}>{keyword}</span>
        </div>
      </Col>
      <Col dangerouslySetInnerHTML={{ __html: value }}></Col>
    </Row>
  )),
];

KeywordList.propTypes = {
  keywords: PropTypes.array,
};

export default KeywordList;



// WEBPACK FOOTER //
// src/components/shared/KeywordsSection/KeywordList/index.jsx